import { render, staticRenderFns } from "./ProductTables.vue?vue&type=template&id=3adc6530&scoped=true&"
import script from "./ProductTables.vue?vue&type=script&lang=js&"
export * from "./ProductTables.vue?vue&type=script&lang=js&"
import style0 from "./ProductTables.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductTables.vue?vue&type=style&index=1&id=3adc6530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc6530",
  null
  
)

export default component.exports